import { ProjectCoreBase } from "./project.core.base"


export class ProjectCore extends ProjectCoreBase {

}